export default __webpack_public_path__ + "static/media/logo.253300ec.png";